import type { ProjectDocType } from '@ast-data/shared';
import { projectMeasureLabel } from './projectTitle';

/**
 * "{Maßnahmennummer} - {Kurztitel}" as a plain string (id as a last resort so a
 * brand-new project without a number/title still shows something). For sorting,
 * search, chip labels and other places that need a string rather than a node.
 */
export function projectLabelText(project: ProjectDocType): string {
    return projectMeasureLabel(project) || project.id;
}
